var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoSymbolX2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5405 21C17.735 21 21.9459 16.9706 21.9459 12C21.9459 7.02944 17.735 3 12.5405 3C7.34599 3 3.13502 7.02944 3.13502 12C3.13502 16.9706 7.34599 21 12.5405 21ZM12.5405 23C18.8893 23 24.036 18.0751 24.036 12C24.036 5.92487 18.8893 1 12.5405 1C6.19166 1 1.04492 5.92487 1.04492 12C1.04492 18.0751 6.19166 23 12.5405 23Z",
    className: "Icon-fill-color"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.18007 19L19.8558 4L21.3337 5.41421L5.658 20.4142L4.18007 19Z",
    className: "Icon-fill-color"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSymbolX2);
export default __webpack_public_path__ + "static/media/NoSymbolX2.bbfc14aae3320bcad655050d19f8a4ab.svg";
export { ForwardRef as ReactComponent };